import { Divider } from '@mui/joy';
import { useEffect } from 'react';
import { getCurrentTabDetails } from '../controllers/currentTabData';
import Layout from '../Layout';
import UserDataStore from '../LinkDataStore';
import { useDispatchContext, useStateContext } from '../Store/Context';
import CategoryAndLinks from './DashboardComponents/CategoryAndLinks';
import CurrentTabData from './DashboardComponents/CurrentTabData';
import TopBand from './DashboardComponents/TopBand';
import NavBar from './WebPageComponents/NavBar';

const Dashboard = () => {

	const dispatch = useDispatchContext();
	const {payload, medium} = useStateContext();

	useEffect(()=>{
		async function updateTabData() {
			await getCurrentTabDetails(dispatch);
		}

		updateTabData();
	}, [dispatch]);

	return (
		<>
			{medium==='web'&&<NavBar/>}
			<Layout>
				<UserDataStore>
					{medium==='extension'&&<TopBand/>}
					{medium==='extension'&&<Divider/>}
					<CurrentTabData urlData={payload}/>
					<CategoryAndLinks/>
				</UserDataStore>
			</Layout>
		</>
	)
}

export default Dashboard;